<template>
  <div class="column-3-2">
    <h4 class="footer-title">
      {{ typeText[type] }}
    </h4>
    <div
      class="row-start-1 row-start-2 row-start-3 
                    row-start-4 row-start-5 row-start-6 row-start-7 hidden"
    ></div>
    <ul class="ul-align-grid">
      <li
        v-for="(genre, index) in footerInfo?.genres"
        :key="genre.id"
        :class="index < 4 ? `row-start-${index + 1}` : ``"
      >
        <a :href="urlFormatter(genre)">
          {{
            $t(formattedTypeText[type], {
              genre: genre.name
            })
          }}
        </a>
      </li>
    </ul>
  </div>
</template>

<script setup>
import { onMounted, ref } from "vue";
import { useI18n } from "vue-i18n";
import { useGeneral } from "@/composables/useGeneral";
import { ROUTE_VALUES, DEFAULT_LANGUAGES } from "@/constants.js";
import { useRoute } from "vue-router";

const { footerInfo } = useGeneral();

const route = useRoute();
const { t } = useI18n();
const props = defineProps({
  type: {
    type: String,
    default: "concerts"
  }
});
const langIndex = ref(0);
const languajes = ref(["es", "de", "en", "fr", "it", "pt"]);
const typeText = ref({
  concerts: t("general.footer.concertsGenres"),
  festivals: t("general.footer.festivalsGenres"),
  venues: t("general.footer.venuesGenres")
});
const formattedTypeText = ref({
  concerts: "general.footer.concertsGenresGenre",
  festivals: "general.footer.festivalsGenresGenre"
});

const urlFormatter = (genreData = {}) => {
  let url = "/" + (route.params.region || "es") + "/";
  if (props.type === "festivals") {
    url += ROUTE_VALUES.festivalStrinigs[langIndex.value];
  } else if (props.type === "concerts") {
    url += ROUTE_VALUES.concertStrinigs[langIndex.value];
  }
  url += "/geo/" + (footerInfo.value.country_slug || "espana");
  if (genreData.slug) {
    url += "/gen/" + genreData.slug;
  }
  return url;
};

onMounted(() => {
  let actualLang = DEFAULT_LANGUAGES[route.params.region || "es"];
  langIndex.value = languajes.value.findIndex(lang => lang === actualLang);
});
</script>

<style lang="scss" scoped>
h4 {
  margin-bottom: 7px;
  font-weight: 600;
}
.ul-align-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  column-gap: 20px;
  li {
    color: $textosecundario;
    font-size: 13px;
  }
}
</style>
